"use_strict"

class Searchbar {

	constructor () {
		this._buttonOpening = document.querySelector('.js-search-open')
		this._buttonClosing = document.querySelector('.js-search-close')
		this._searchform    = document.querySelector('.js-search-form')

		if ( !this._buttonOpening || !this._buttonClosing || !this._searchform ) return;

		this._bindUIActions()
	}

	_bindUIActions () {
		this._buttonOpening.addEventListener( 'click', () => this._openSearchbar() )
		this._buttonClosing.addEventListener( 'click', () => this._closeSearchbar() )
	}

	_openSearchbar () {
		this._searchform.style.display = 'block'
	}

	_closeSearchbar () {
		this._searchform.style.display = 'none'
	}
}

export { Searchbar }
